import BaseEditor from "@monaco-editor/react"
import {
  EDITOR_PALETTE_OPTIONS,
  EDITOR_FONT_SIZE_OPTIONS,
  EDITOR_LINE_HEIGHT_OPTIONS,
  useEditorSettings,
} from "@/v2-backoffice-client/components/editor/editor.settings"
import SettingSection from "@/v2-backoffice-client/settings/SettingSection"
import SettingOptionGroup from "@/v2-backoffice-client/settings/SettingOptionGroup"

const PREVIEW_SAMPLE = `{
  "id": "MapLayer_NO_Income",
  "blendMode": "average",
  "minScale": 40000,
  "labelingInfo": [
    { "fieldName": "snitt_innt" }
  ]
}`

/**
 * Theming for every code editor in the backoffice (layer workbench,
 * diff views, create dialog, …). The preview is a real read-only Monaco
 * instance, so what you see is exactly what the editors render.
 */
function SettingEditor() {
  const {
    palette,
    setPalette,
    fontSizeKey,
    setFontSizeKey,
    lineHeightKey,
    setLineHeightKey,
    monacoTheme,
    fontSize,
    lineHeight,
  } = useEditorSettings()

  return (
    <SettingSection
      title="Code Editors"
      description="Controls the color palette and typography of every code editor across the backoffice."
      preview={
        <div className="h-48 overflow-hidden rounded-md border border-border">
          <BaseEditor
            value={PREVIEW_SAMPLE}
            defaultLanguage="json"
            theme={monacoTheme}
            options={{
              readOnly: true,
              minimap: { enabled: false },
              fontSize,
              lineHeight,
              scrollBeyondLastLine: false,
              wordWrap: "on",
              padding: { top: 8, bottom: 8 },
            }}
          />
        </div>
      }
    >
      <div className="space-y-5">
        <div>
          <p className="text-xs font-medium text-muted-foreground mb-2">
            Color Palette
          </p>
          <SettingOptionGroup
            options={EDITOR_PALETTE_OPTIONS}
            value={palette}
            onChange={setPalette}
          />
        </div>

        <div>
          <p className="text-xs font-medium text-muted-foreground mb-2">
            Font Size
          </p>
          <SettingOptionGroup
            options={EDITOR_FONT_SIZE_OPTIONS}
            value={fontSizeKey}
            onChange={setFontSizeKey}
          />
        </div>

        <div>
          <p className="text-xs font-medium text-muted-foreground mb-2">
            Line Height
          </p>
          <SettingOptionGroup
            options={EDITOR_LINE_HEIGHT_OPTIONS}
            value={lineHeightKey}
            onChange={setLineHeightKey}
          />
        </div>
      </div>
    </SettingSection>
  )
}

export default SettingEditor
